/* eslint-disable import/first,import/order */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionShareEmailVideoRecord, ActionShareUserPortfolio} from '../../../store/actions/actions-request';
import {ActionInviteEmailVideosession} from '../../../store/actions/actions-videosession';
import {CloseIcon} from '../../SvgComponents/SvgComponents';
import ModalBaseLayout from '../ModalBaseLayout';
import ValidationUtils from '../../../utils/utils-validation';
import {t, tTemplate} from '../../../services/i18nHandler';

const SelectedInputItem = (props) => {
  const {value, index, removeClick} = props;

  return (
    <div className="select-span-wrap">
      <span className="select-span">{value}</span>
      <span className="select-span_close" title="удалить" onClick={() => removeClick(index)}>+</span>
    </div>
  );
};

class ModalShareLink extends Component {
  constructor(props) {
    super(props);

    this.settings = ModalBaseLayout.getInitialSettings({
      className: 'modal-center',
      closeButton: true,
      keyboard: true,
    });

    this.state = {
      inputData: [],
      inputValue: '',
    };
  }

  onChangeInput = (e) => {
    this.setState({
      inputValue: e.target.value,
    });
  };

  onKeyDown = (e) => {
    if (e.key === 'Enter' && e.target.value) {
      this.addInputData(e.target.value);
    }
  };

  removeClick = (removeIndex) => {
    const {inputData} = this.state;

    const newInputData = inputData.filter((item, index) => {
      if (removeIndex !== index) return item;
    });

    this.setState({
      inputData: newInputData,
    });
  };

  onBlur = (e) => {
    if (e.target.value) {
      this.addInputData(e.target.value);
    }
  };

  addInputData = (value) => {
    const {inputData} = this.state;
    const isValidEmail = ValidationUtils.Form.isEmail(value);

    if (isValidEmail && inputData.length < 3) {
      const newInputData = [...inputData];
      newInputData.push(value);

      this.setState({
        inputData: newInputData,
        inputValue: '',
      });
    } else {
      this.setState({
        inputValue: '',
      });
    }
  };

  shareClick = () => {
    const {inputData} = this.state;
    const {type, text, sessionId} = this.props;

    switch (type) {
    case 'shareVideoSession':
      // TODO: GET VIDEOSESSION ID;
      this.props.ActionInviteEmailVideosession({
        emails: inputData,
        sessionId,
        message: text,
      });
      break;
    case 'shareUserVideoSession':
      this.props.ActionShareEmailVideoRecord({
        emails: inputData,
      }, sessionId);
      break;

    case 'sharePortfolio':
      this.props.ActionShareUserPortfolio({
        emails: inputData,
      });
      break;
    default:
    }
  };

  render() {
    const {inputData, inputValue} = this.state;
    const {title, text} = this.props;

    console.log(this.props);

    return (
      <ModalBaseLayout {...this.settings}>
        <div className="modal-container max900">
          <div className="modal-header">
            <h3 className="modal-header_title">{title}</h3>
            <button className="modal-close-btn" onClick={this.props.ActionModalHide}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal-content">
            <div className="modal-share-link">
              <div className="modal-share-link_title">
                <h4 className="modal-share-link_title-text">{t('inputs.email2')}</h4>
                <span className="modal-share-link_title-meta">
                  (
                  {tTemplate('vs.maxEmailCount', 3)}
                  )
                </span>
              </div>
              <div className="modal-share-link_inputs">
                <div className="modal-share-link_input-wrap">
                  <label htmlFor="email-input" className="pseudo-input-wrap">
                    {inputData.map((value, index) => (
                      <SelectedInputItem
                        key={index}
                        value={value}
                        index={index}
                        removeClick={this.removeClick}
                      />
                    ))}
                    <input
                      type="text"
                      className="no-styling-input"
                      value={inputValue}
                      onChange={this.onChangeInput}
                      onKeyDown={this.onKeyDown}
                      onBlur={this.onBlur}
                      id="email-input"
                    />
                  </label>
                </div>
              </div>
            </div>
            <div className="modal-generate">
              <div className="modal-generate_inputs">
                <div className="modal-generate_input">
                  {text}
                </div>
              </div>
              <div className="modal-generate_btn">
                <button
                  onClick={this.shareClick}
                  className="btn btn-base"
                  disabled={!inputData.length}
                >
                  {t('common.send')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }
}

ModalShareLink.propTypes = {};

function mapStateToProps() {
  return {};
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionInviteEmailVideosession,
    ActionShareEmailVideoRecord,
    ActionShareUserPortfolio,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalShareLink);
